import {
  Tax,
} from '@dapi/sdk';
import {
  currency,
  currencyCode,
} from './currency';

export const taxes: Tax[] = [
  {
    code: 'QXAP',
    currencyCode: currencyCode,
    currency,
    value: 23000
  }
];
